import { ReactNode } from 'react';
import { default as KeyboardArrowRightIcon } from '@mui/icons-material/KeyboardArrowRight';
import { IconWrapper, MenuLinkWrapper } from './styledComponents';

interface Props {
  onClick: () => void;
  children: ReactNode;
  dataTestId?: string;
  withArrow?: boolean;
}
export const MenuLink = ({
  onClick,
  children,
  dataTestId = 'menu-link',
  withArrow
}: Props) => {
  return (
    <MenuLinkWrapper data-testid={dataTestId} onClick={onClick}>
      {children}
      {withArrow && (
        <IconWrapper>
          <KeyboardArrowRightIcon />
        </IconWrapper>
      )}
    </MenuLinkWrapper>
  );
};
